import { useState } from 'react'

import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faEye } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Typography } from '@material-ui/core'

import { pdf } from 'common/api'

import PDFDocumentViewerModal from './PDFDocumentViewerModal'

type ViewDocumentTriggerProps = {
  scid: number
  batchId: string
  recordId: string
  firstName: string
  lastName: string
  label: string
  showScrim?: boolean
}
const ViewDocumentTrigger = ({
  firstName,
  lastName,
  label,
  scid,
  batchId,
  recordId,
  showScrim,
}: ViewDocumentTriggerProps) => {
  const [pdfData, setPdfData] = useState<ArrayBuffer>()
  const [isModalOpen, setPdfModalOpen] = useState(false)
  const [hasError, setHasError] = useState(false)
  const displayPdf = () => {
    setHasError(false)
    pdf
      .get(`/api/colleges/${scid}/batches/${batchId}/documents/${recordId}/pdf`)
      .then((payload) => {
        setPdfData(payload)
        setPdfModalOpen(true)
      })
      .catch(() => {
        setHasError(true)
      })
  }
  return (
    <>
      <IconButton
        color="primary"
        aria-label={`View document ${label}`}
        onClick={displayPdf}
      >
        <FontAwesomeIcon icon={faEye as IconProp} />
      </IconButton>
      {hasError && (
        <Typography
          component="span"
          color="error"
          role="alert"
        >
          Unable to load pdf document
        </Typography>
      )}

      <PDFDocumentViewerModal
        pdfTitle={`${label} for ${firstName} ${lastName}`}
        open={isModalOpen}
        bytes={pdfData}
        showScrim={showScrim}
        onCancel={() => {
          setPdfData(undefined)
          setPdfModalOpen(false)
        }}
      />
    </>
  )
}

export default ViewDocumentTrigger
